import { FC } from 'react'

interface Props {
  title: string
  description?: string
}

const SectionTitle: FC<Props> = ({ title, description }) => (
  <div>
    <h2 className='font-semibold text-[#151930]'>{title}</h2>
    {description && <p className='text-[14px] text-[#151930]/50 mt-0.5'>{description}</p>}
  </div>
)

export default SectionTitle
